import { gql } from '@apollo/client';

export const SliceQuarters = gql`
  fragment SliceQuarters on PageBodyQuarters {
    type
    fields {
      copy
      link {
        ...LinkFragment
      }
    }
  }
`;

export const SliceTable = gql`
  fragment SliceTable on PageBodyTable {
    type
    primary {
      bg: background
      layout
      zebra_color
      text
      table_title
      table
    }
  }
`;

export const SliceTextWithImages = gql`
  fragment SliceTextWithImages on PageBodyText_with_images {
    type
    primary {
      title
      copy
      align
      link_text
      aspect_ratio
      link {
        ...LinkFragment
      }
      link_2_text
      link_2 {
        ...LinkFragment
      }
    }
    fields {
      image
      video
      embed
      infogramid
    }
  }
`;

export const SliceAccordion = gql`
  fragment SliceAccordion on PageBodyAccordion {
    type
    primary {
      is_open
      single_display
    }
    fields {
      page {
        ... on Page {
          _meta {
            id
            uid
            tags
            lang
          }
          page_title
          body {
            ...SliceQuarters
            ...SliceTextWithImages
            ...SliceTable
            ...SliceText
          }
        }
      }
    }
  }
`;

export const SlicePoints = gql`
  fragment SlicePointsArsskyrsla on PageBodyPoints {
    type
    fields {
      title
      text
    }
    primary {
      title
      text
      featured_point_title
      featured_point_text
    }
  }
`;

export const SliceFaq = gql`
  fragment SliceFaq on PageBodyFaq {
    type
    primary {
      heading
      single_display
    }
    fields {
      item {
        ... on Faq_item {
          question
          answer
        }
      }
      category {
        ... on Faq_category {
          title
        }
      }
    }
  }
`;

export const SliceInterestCallout = gql`
  fragment SliceInterestCallout on PageBodyInterest_callout {
    type
    label
    fields {
      title
      copy
      sub_title
      number
      number_color
      subtitle_position
      link {
        ...LinkFragment
      }
    }
  }
`;
export const SliceStaffWithContact = gql`
  fragment SliceStaffWithContact on PageBodyStaff_with_contact {
    type
    primary {
      title
    }
    fields {
      employee {
        ... on Employee {
          image
          name
          title
          email
          phone
          location
        }
      }
      show_image
    }
  }
`;
export const SliceStaffWithBio = gql`
  fragment SliceStaffWithBio on PageBodyStaff_with_bio {
    type
    primary {
      title
    }
    fields {
      employee {
        ... on Employee {
          image
          name
          title
          bio
        }
      }
    }
  }
`;

export const SliceNewsCards = gql`
  fragment SliceNewsCards on PageBodyNews_cards {
    type
    primary {
      heading
      heading_link {
        ...LinkFragment
      }
      featured
      articles
    }
    fields {
      article {
        ...LinkFragment
      }
      category {
        ... on Article_category {
          _meta {
            id
            uid
          }
          title
        }
      }
    }
  }
`;

export const SliceMoreInfo = gql`
  fragment SliceMoreInfo on PageBodyMore_info {
    type
    primary {
      title
      expandable
    }
    fields {
      image
      title
      copy
      expandable
    }
  }
`;

export const SliceShortcuts = gql`
  fragment SliceShortcuts on PageBodyShortcuts {
    type
    fields {
      icon
      link {
        ...LinkFragment
      }
      link_text
    }
  }
`;

export const SliceTextWithAuthors = gql`
  fragment ArticleSliceTextWithAuthors on PageBodyText_with_authors {
    type
    primary {
      copy
    }
    fields {
      twa_author {
        ... on Author {
          name
          job_title
          image
        }
      }
    }
  }
`;

export const SliceInfogram = gql`
  fragment ArticleInfogram on PageBodyInfogram {
    type
    primary {
      infogramid
      infogramid_2
      infogramid_3
    }
  }
`;

export const SliceBuzzsprout = gql`
  fragment ArticleBuzzsprout on PageBodyBuzzsprout {
    type
    primary {
      url
    }
  }
`;
export const QuoteExpand = gql`
  fragment QuoteExpand on PageBodyQuote_expand {
    type
    primary {
      title
      copy
      expandable_copy
      top_splitter
    }
    fields {
      author {
        ... on Author {
          name
          job_title
          image
        }
      }
    }
  }
`;

export const arsskyrslaFragments = [
  SliceQuarters,
  SliceAccordion,
  SlicePoints,
  SliceTable,
  SliceFaq,
  SliceInterestCallout,
  SliceStaffWithContact,
  SliceStaffWithBio,
  SliceNewsCards,
  SliceMoreInfo,
  SliceShortcuts,
  SliceTextWithAuthors,
  SliceTextWithImages,
  SliceInfogram,
  SliceBuzzsprout,
  QuoteExpand,
];
